import React, { useState } from 'react';
import {
  Typography,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  Collapse
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Link } from 'react-router-dom';

export const seoMeta = {
  title: 'Пликове за детски и бебешки завивки 100% памук | GoToBed',
  description:
    'Пликове за детски и бебешки завивки от 100% памук. Ранфорс и памучен сатен, размери 105/140, 140/200, 150/210. Изработка по поръчка. Поръчайте от GoToBed.'
};

const seoLinkStyle = {
  color: '#F57819',
  textDecoration: 'underline',
  fontWeight: 600,
  '&:hover': { color: '#A34D08' }
};

export function SeoHeader() {
  const [introExpanded, setIntroExpanded] = useState(false);

  return (
    <Box sx={{ mb: 3 }}>
      <Typography
        component="h1"
        sx={{
          position: 'absolute',
          width: '1px',
          height: '1px',
          padding: 0,
          margin: '-1px',
          overflow: 'hidden',
          clip: 'rect(0, 0, 0, 0)',
          whiteSpace: 'nowrap',
          borderWidth: 0
        }}>
        Пликове за детски и бебешки завивки – 100% памук
      </Typography>
      <Typography variant="h6" component="p" fontWeight={600} sx={{ mb: 2 }}>
        Пликове за детски и бебешки завивки – 100% памук
      </Typography>
      <Box
        sx={{
          ...(!introExpanded && {
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden'
          })
        }}>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Пликовете за детски завивки предпазват завивката и осигуряват комфортен и хигиеничен сън
          за бебета и деца. В тази категория ще откриете пликове за бебешки и детски завивки от 100%
          памук, които се предлагат в едноцветни и шарени (с принт) десени. Основното ни предимство
          е голямото разнообразие от размери, което позволява лесно да изберете подходящ детски плик
          за завивка – например 105/140, 115/150, 140/200 и 150/210.
        </Typography>
      </Box>
      <Button
        onClick={() => setIntroExpanded(!introExpanded)}
        size="small"
        sx={{
          color: '#F57819',
          textTransform: 'none',
          fontWeight: 600,
          p: 0,
          minWidth: 0,
          '&:hover': { backgroundColor: 'transparent', textDecoration: 'underline' }
        }}>
        {introExpanded ? 'Скрий' : 'Прочетете повече'}
      </Button>
    </Box>
  );
}

export default function SeoBody() {
  return <SeoBodyDetskiPlikove />;
}

function SeoBodyDetskiPlikove() {
  const [expanded, setExpanded] = useState(false);

  return (
    <Box sx={{ mt: 6 }}>
      {/* H2: Пликове за детски и бебешки завивки – плик за детска завивка от 100% памук */}
      <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
        Пликове за детски и бебешки завивки – плик за детска завивка от 100% памук
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        В тази категория ще откриете пликове за детски завивки и пликове за бебешки завивки,
        изработени от висококачествени 100% памучни платове. Пликът за завивка е важна част от
        детското спално бельо, защото предпазва завивката и осигурява комфортен, чист и хигиеничен
        сън. Всеки детски плик за завивка се изработва по поръчка и се предлага в различни размери.
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        В GoToBed предлагаме пликове за детски завивки в голямо разнообразие от размери, което
        позволява лесно да намерите подходящ размер както за бебешка завивка, така и за по-голямо
        детско одеяло.
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        Всички пликове се изработват внимателно в България от памучни платове ранфорс и памучен
        сатен, сертифицирани по OEKO-TEX Standard 100. Този сертификат гарантира, че текстилът е
        безопасен за бебета и деца и не съдържа вредни вещества, което е особено важно за
        чувствителната детска кожа.
      </Typography>
      <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
        Ако търсите конкретна материя, можете да разгледате:
      </Typography>
      <Box sx={{ mb: 4, pl: 2 }}>
        <Typography
          variant="body1"
          component={Link}
          to="/produkti/detsko-spalno-belio/detski-plikove/2/10/2"
          sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
          детски пликове ранфорс
        </Typography>
        <Typography
          variant="body1"
          component={Link}
          to="/produkti/detsko-spalno-belio/detski-plikove/2/10/1"
          sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
          детски пликове памучен сатен
        </Typography>
      </Box>

      <Collapse in={expanded} collapsedSize={0}>
        {/* H2: Пликове за детски завивки в много размери */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Пликове за детски завивки в много размери
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Пликове за детски завивки в различни размери
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Предлагаме пликове за детски и бебешки завивки в голямо разнообразие от размери, което
          позволява лесно да намерите подходящия вариант за вашата завивка или детско одеяло.
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Сред най-търсените са:
        </Typography>
        <Box component="ul" sx={{ mb: 2, pl: 4, color: 'text.secondary' }}>
          <li>плик за бебешка завивка 105/140 (105х140) см</li>
          <li>плик за детска завивка 140/200 (140х200) см</li>
          <li>плик за детска завивка 150/210 (150х210) см</li>
          <li>плик за детска завивка 160/220 (160х220) см</li>
        </Box>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Тези размери са широко използвани при бебешко и детско спално бельо и осигуряват удобно
          покриване на завивката.
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Предлагаме пликове за детски завивки със следните размери:
        </Typography>
        <Box sx={{ mb: 2, pl: 2 }}>
          {[
            '103/130',
            '105/140',
            '115/150',
            '115/160',
            '130/200',
            '140/200',
            '140/210',
            '150/200',
            '150/210',
            '150/220',
            '160/200',
            '160/210',
            '160/220',
            '180/220',
            '200/200',
            '200/220'
          ].map((item) => (
            <Typography key={item} variant="body1" sx={{ color: 'text.secondary' }}>
              {item}
            </Typography>
          ))}
        </Box>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Благодарение на този широк избор можете лесно да намерите подходящ плик за бебешка завивка
          или плик за детско одеяло, дори когато размерът е по-нестандартен.
        </Typography>

        {/* H2: Памучни пликове за детски завивки – комфорт и безопасност */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Памучни пликове за детски завивки – комфорт и безопасност
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Всички пликове се изработват от 100% памучни материи, които са дишащи, меки и приятни на
          допир. Памукът е особено подходящ за детско спално бельо, защото е естествен материал,
          който позволява на кожата да диша и намалява риска от раздразнения.
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Това осигурява по-комфортен сън както за бебетата, така и за по-големите деца.
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Предлагаме два вида плат:
        </Typography>

        <Typography variant="h6" component="h3" fontWeight={600} sx={{ mb: 1 }}>
          Ранфорс
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Плътен, лек и издръжлив 100% памучен плат, който е много подходящ за ежедневна употреба и
          често пране. Можете да разгледате нашите{' '}
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/detsko-spalno-belio/detski-plikove/2/10/2"
            sx={seoLinkStyle}>
            детски пликове ранфорс
          </Typography>
          , които са практичен избор за детско спално бельо и осигуряват комфорт по време на сън.
        </Typography>

        <Typography variant="h6" component="h3" fontWeight={600} sx={{ mb: 1, mt: 2 }}>
          Памучен сатен
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          По-фина и гладка памучна материя с лек естествен блясък и по-меко усещане. Ако
          предпочитате по-гладка и деликатна тъкан, можете да изберете{' '}
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/detsko-spalno-belio/detski-plikove/2/10/1"
            sx={seoLinkStyle}>
            детски пликове памучен сатен
          </Typography>
          , които съчетават мекота, дишаемост и приятно усещане при допир.
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          И двата вида плат са дишащи, приятни за кожата и подходящи за детско спално бельо.
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          За пълен комплект детско спално бельо можете да комбинирате плика с{' '}
          <Typography
            variant="body1"
            component={Link}
            to="/kategorii/detsko-spalno-belio/detski-kalufki/2/8"
            sx={seoLinkStyle}>
            детски калъфки за възглавници
          </Typography>
          ,{' '}
          <Typography
            variant="body1"
            component={Link}
            to="/kategorii/detsko-spalno-belio/detski-charshafi/2/7"
            sx={seoLinkStyle}>
            детски чаршафи
          </Typography>
          ,{' '}
          <Typography
            variant="body1"
            component={Link}
            to="/kategorii/detsko-spalno-belio/detski-charshafi-s-lastik/2/9"
            sx={seoLinkStyle}>
            детски чаршафи с ластик
          </Typography>
          , изработени от същите 100% памучни материи.
        </Typography>

        {/* H2: Предимства на нашите пликове за детски завивки */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2, mt: 4 }}>
          Предимства на нашите пликове за детски завивки
        </Typography>
        <Box component="ul" sx={{ mb: 2, pl: 4, color: 'text.secondary' }}>
          <li>&#10004; изработени от 100% памук</li>
          <li>&#10004; избор между ранфорс и памучен сатен</li>
          <li>&#10004; голямо разнообразие от размери</li>
          <li>&#10004; подходящи за бебешки и детски завивки</li>
          <li>&#10004; дишащи и приятни на допир материи</li>
          <li>&#10004; платове със сертификат OEKO-TEX Standard 100</li>
          <li>&#10004; произведени в България</li>
        </Box>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Нашите пликове за детски завивки са практично решение за родители, които търсят
          качествено, безопасно и удобно детско спално бельо.
        </Typography>

        {/* H2: Популярни размери пликове за детски завивки */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Популярни размери пликове за детски завивки
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Сред най-търсените размери са:
        </Typography>
        <Box sx={{ mb: 4, pl: 2 }}>
          {[
            'плик за детска завивка 140/200 (140х200) см',
            'плик за детска завивка 150/210 (150х210) см',
            'плик за детска завивка 160/220 (160х220) см',
            'плик за бебешка завивка 105/140 (105х140) см'
          ].map((item) => (
            <Typography key={item} variant="body1" sx={{ color: 'text.secondary' }}>
              {item}
            </Typography>
          ))}
        </Box>

        {/* H2: Срок за изработка */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Срок за изработка
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Всички пликове се изработват индивидуално след направена поръчка, според избрания размер.
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Срокът за изработка е между 3 и 10 работни дни, като в повечето случаи поръчките са готови
          в рамките на 4–7 работни дни.
        </Typography>

        {/* H2: Детско спално бельо от 100% памук */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Детско спално бельо от 100% памук
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Ако търсите качествено детско спално бельо от 100% памук, можете да разгледате и
          останалите продукти в нашия магазин. Предлагаме разнообразие от{' '}
          <Typography
            variant="body1"
            component={Link}
            to="/kategorii/detsko-spalno-belio/detski-charshafi/2/7"
            sx={seoLinkStyle}>
            детски чаршафи
          </Typography>
          ,{' '}
          <Typography
            variant="body1"
            component={Link}
            to="/kategorii/detsko-spalno-belio/detski-charshafi-s-lastik/2/9"
            sx={seoLinkStyle}>
            детски чаршафи с ластик
          </Typography>
          ,{' '}
          <Typography
            variant="body1"
            component={Link}
            to="/kategorii/detsko-spalno-belio/detski-kalufki/2/8"
            sx={seoLinkStyle}>
            детски калъфки за възглавници
          </Typography>
          , изработени от висококачествени памучни материи като ранфорс и памучен сатен.
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Всички продукти се изработват в България от платове със сертификат OEKO-TEX Standard 100,
          което гарантира безопасност и комфорт за бебешката и детската кожа.
        </Typography>
      </Collapse>
      <Button
        onClick={() => setExpanded(!expanded)}
        sx={{
          color: '#F57819',
          textTransform: 'none',
          fontWeight: 600,
          mb: 3,
          '&:hover': { backgroundColor: 'rgba(212, 175, 55, 0.08)' }
        }}>
        {expanded ? 'Скрий' : 'Прочетете повече'}
      </Button>

      {/* H2: ЧЗВ */}
      <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 3 }}>
        Често задавани въпроси за пликове за детски завивки
      </Typography>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Как да избера правилния размер плик за детска завивка?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
            За да изберете подходящ плик за детска завивка, измерете ширината и дължината на
            завивката или одеялото. Най-добре е пликът да бъде със същия или много близък размер, за
            да може завивката да стои удобно вътре и да не се събира по време на сън.
          </Typography>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            В нашия магазин ще откриете пликове за детски и бебешки завивки в различни размери,
            което позволява лесно да намерите подходящия вариант.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Подходящи ли са пликовете за бебешки завивки?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
            Да. Предлагаме по-малки размери пликове, които са подходящи за бебешки завивки и одеяла,
            например:
          </Typography>
          <Box component="ul" sx={{ mb: 1, pl: 4, color: 'text.secondary' }}>
            <li>плик за бебешка завивка 103/130 (103х130) см</li>
            <li>плик за бебешка завивка 105/140 (105х140) см</li>
            <li>плик за бебешка завивка 115/150 (115х150) см</li>
          </Box>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Тези размери са често използвани за бебешко спално бельо и осигуряват удобство и комфорт
            за бебето.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Подходящи ли са пликовете и за по-големи детски завивки?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
            Да. В нашия магазин ще откриете и по-големи размери пликове, които са подходящи за
            детски и тийнейджърски легла, например:
          </Typography>
          <Box component="ul" sx={{ mb: 1, pl: 4, color: 'text.secondary' }}>
            <li>плик за детска завивка 140/200 (140х200) см</li>
            <li>плик за детска завивка 150/210 (150х210) см</li>
            <li>плик за детска завивка 160/220 (160х220) см</li>
          </Box>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Тези размери са много разпространени при детските легла и осигуряват комфортен сън.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Какъв плат да избера – ранфорс или памучен сатен?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
            И двата плата са 100% памук и са много подходящи за детско спално бельо.
          </Typography>
          <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
            Ранфорс – по-плътен и издръжлив памучен плат, който е подходящ за ежедневна употреба и
            често пране. Ако търсите здрав и практичен вариант, можете да изберете{' '}
            <Typography
              variant="body1"
              component={Link}
              to="/produkti/detsko-spalno-belio/detski-plikove/2/10/2"
              sx={seoLinkStyle}>
              детски пликове ранфорс
            </Typography>
          </Typography>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Памучен сатен – по-фина и гладка памучна материя с лек естествен блясък и по-меко
            усещане. Ако предпочитате по-гладка и деликатна материя, добър избор са{' '}
            <Typography
              variant="body1"
              component={Link}
              to="/produkti/detsko-spalno-belio/detski-plikove/2/10/1"
              sx={seoLinkStyle}>
              детски пликове памучен сатен
            </Typography>
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Подходящи ли са памучните пликове за детска кожа?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
            Да. Пликовете за завивки от 100% памук са много подходящи за бебешка и детска кожа.
            Памукът е естествен материал, който е дишащ, мек и приятен на допир.
          </Typography>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Платовете са сертифицирани по OEKO-TEX Standard 100, което гарантира, че текстилът не
            съдържа вредни вещества.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Свиват ли се памучните пликове за завивки след пране?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Както всички изделия от 100% памук, и пликовете за завивки могат да имат естествена
            свиваемост около 4–5% след първите пранета. Това е нормално свойство на памучните
            материи като ранфорс и памучен сатен.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Как да поддържам плика за детска завивка?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
            Памучните пликове за завивки могат да се перат в пералня при температура до 40°C.
            Препоръчително е да се изперат преди първа употреба.
          </Typography>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Редовното пране помага да се поддържа хигиената на детското спално бельо и осигурява
            комфортен сън.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Къде се изработват пликовете за детски завивки?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Всички пликове за детски завивки се изработват в България, специално за всяка поръчка и
            според избрания размер.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            За колко време се изработва плик за детска завивка?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Пликовете се изработват индивидуално по поръчка, като срокът за изработка е между 3 и 10
            работни дни. В повечето случаи поръчките са готови в рамките на 4–7 работни дни.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}
